import React, { createContext, useContext } from 'react';
import stores from 'stores';
import type { IStores } from 'stores/RootStore';

const StoreContext = createContext<IStores>(stores);

// Cria o componente Provedor que disponibilizará as stores para os componentes filhos
export const StoreProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <StoreContext.Provider value={stores}>
            {children}
        </StoreContext.Provider>
    );
};


export const useStore = (): IStores => useContext(StoreContext);